import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ImageRadioButtonSize, ImageRadioButton } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { uniqueId } from '@as-react/common-utils';
import { Box, Stack, TextAlpha } from '@yonderland/andes-react';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { generateSwatchFromProductColor, getDiscountIconContent } from '../../../util/SwatchUtil';
export const MiniPDPSwatchesCarousel = ({ colors, selectedColor, productCode, productImageCdnDomains, setProductColor, showTitle, boxProps = {
    paddingBlockStart: { md: '2' },
    paddingBlockEnd: { base: '3', md: '4' },
}, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { productSwatchConfig } = useAemConfig();
    const carouselId = useMemo(() => uniqueId(), []);
    const renderSlide = useCallback((colour, index) => {
        const key = `color_swatch_${carouselId}_${colour.colourId}_${index}`;
        return (_jsx("div", { children: _jsx(ImageRadioButton, { id: key, name: `color_swatch_${carouselId}`, value: colour.colourId.toString(), checked: colour.colourId === selectedColor.colourId, imageUrl: colour.swatch, imageLazyLoad: true, textOverlay: true, textImage: getDiscountIconContent(colour, productSwatchConfig), title: colour.color, onChange: () => setProductColor(colour.colourId), size: ImageRadioButtonSize.SMALL }) }, key));
    }, [colors, selectedColor, setProductColor]);
    const colorSwatches = colors.map(productColor => generateSwatchFromProductColor(productColor, selectedColor, productCode, productImageCdnDomains));
    const hasSwatches = colorSwatches && colorSwatches.length > 1;
    const renderSwatches = () => (_jsx(Stack, { gap: "2", wrap: "wrap", children: colorSwatches.map(renderSlide) }));
    if (showTitle) {
        return (_jsxs(Box, Object.assign({}, boxProps, { children: [_jsxs(Box, { children: [_jsx(TextAlpha, { variant: "bodyS", as: "span", strong: true, children: `${t('product:pdp.color')}: ` }), _jsx(TextAlpha, { variant: "bodyS", as: "span", testId: "color_name", children: selectedColor.description })] }), hasSwatches ? _jsx(Box, { paddingBlockStart: "1", children: renderSwatches() }) : null] })));
    }
    if (hasSwatches) {
        return _jsx(_Fragment, { children: renderSwatches() });
    }
    return null;
};
